import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MemberService} from '@services/member.service';
import {NgClass, NgStyle} from '@angular/common';
import {AchievementRowComponent} from '@components/achievement-row/achievement-row.component';
import {MatchService} from '@services/match.service';
import {Title} from '@angular/platform-browser';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {Member, MemberRole, MemberTiny} from '@/app/core/models/member';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';
import {determineRoleIcon} from '@/app/core/utils/memberUtils';
import {environment} from '@/environments/environment';
import {TranslateDynamicService} from '@services/translate-dynamic.service';
import {SeparatorComponent, TitleComponent} from '@/app/shared';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';

@Component({
	selector: 'app-roster-pokemon-vgc',
	imports: [
		AchievementRowComponent,
		TranslatePipe,
		LastVideosComponent,
		NgStyle,
		TitleComponent,
		UpcomingMatchsComponent,
		SeparatorComponent,
		NgClass,
	],
	templateUrl: './roster-pokemon-vgc.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./roster-pokemon-vgc.component.css']
})
export class RosterPokemonVgcComponent implements OnInit {

	constructor(
		private readonly memberService: MemberService,
		private readonly matchService: MatchService,
		private readonly titleService: Title,
		protected readonly translateDynamicService: TranslateDynamicService
	) { }

	protected readonly MemberRole = MemberRole;
	protected readonly determineRoleIcon = determineRoleIcon;

	members: Member[] = [];
	minioBaseUrl = environment.minioBaseUrl;
	matches: CalendarGroupByDate[] = [];

	ngOnInit(): void {
		this.loadMember();
		this.loadMatches();
	}

	loadMember() {
		this.memberService.getVgcMember('POKEMON_VGC').subscribe({
			next: (members) => {
				this.members = members;
				console.log("members", this.members)
			},
			error: (error) => {
				console.error('Error fetching member:', error);
			}
		});
	}

	loadMatches() {
		this.matchService.getUpcomingMatchesByEventType('POKEMON_VGC').subscribe({
			next: (matches) => {
				this.matches = matches;
			},
			error: (error) => {
				console.error('Error fetching matches:', error);
			}
		})
	}
}
